import React , { useRef, useEffect }from "react";
import "../../Stylesheets/Banner/Banner.scss";
import Navbar from "../Navbar/Navbar";
import BannerVideo from "../../assests/Images/Banner/banner-text.png";
import play_new from "../../assests/Images/Banner/play_new.png"
import { Pannellum, PannellumVideo } from "pannellum-react";
import full_view from '../../assests/Images/360_img/full_view.jpg'
const Banner = () => {
  // const iframeRef = useRef(null);

  // useEffect(() => {
  //   const iframe = iframeRef.current;

  //   // Right-click event listener
  //   const handleContextMenu = (event) => {
  //     // Handle right-click functionality here
  //     console.log('Right-clicked inside the iframe!');

  //     // Prevent the default context menu
  //     event.preventDefault();
  //   };

  //   // Wheel event listener
  //   const handleWheel = (event) => {
  //     // Check if the right mouse button is pressed
  //     if (event.button === 2) {
  //       // Prevent the default zoom behavior
  //       event.preventDefault();

  //       // Handle right-click functionality here
  //       console.log('Right-clicked and prevented zoom inside the iframe!');
  //     }
  //   };

  //   // Attach event listeners
  //   iframe.contentWindow.addEventListener('contextmenu', handleContextMenu);
  //   iframe.contentWindow.addEventListener('wheel', handleWheel);

  //   // Cleanup event listeners on component unmount
  //   return () => {
  //     iframe.contentWindow.removeEventListener('contextmenu', handleContextMenu);
  //     iframe.contentWindow.removeEventListener('wheel', handleWheel);
  //   };
  // }, [iframeRef]);

  return (
    <div className="banner-main-wrapper" id="main_page_banner" >
        <Navbar />
        <div className="cover_iframe">
        {/* <iframe src={process.env.PUBLIC_URL + '/view_new.html'} id="iframe_codoid" ref={iframeRef} className="iframe_size"  /> */}
        {/* <iframe src={process.env.PUBLIC_URL + '/view_new.html'} id="iframe_codoid"  className="iframe_size"  /> */}
        <Pannellum
        width="100%"
        height="100%"
        image={full_view}
        autoRotate="5"
        pitch={10}
        yaw={180}
        hfov={110}
        autoLoad
        className="iframe_size"
        onLoad={() => {
            console.log("panorama loaded");
        }}
    ></Pannellum>
        </div>
      <div className="banner-inner-wrapper container">
      
        {/* <div className="banner-img-wrap">
        <button>
          <img
            src={play_new}
            className="banner-video"
            alt="banner-video"
          ></img>
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Banner;
